<template>
  <div>
    <div class="content-i">
      <div class="content-box">
        <div class="row">
          <div class="col-8">
            <div class="element-wrapper">
              <h6 class="element-header">{{ t('clientSettingsHeader', 'clientSettingsHeader')}}</h6>
              <div class="element-box mb-0">
                <template v-if="!loadingList && attributeList">
                  <div class="row mx-0 text-center form-line form-group mb-0" v-if="attributeList">
                    <div class="col-4 flex-display">{{ t('clientSettingsSelectAttributeLabel', 'clientSettingsSelectAttributeLabel') }}</div>
                    <div class="col-8">
                      <b-form-select v-model="selectedSettingsAttribute" @change="setClientSettingAttribute($event)">
                        <option v-for="attribute in attributeList" :key="attribute.attribute" :value="attribute.attribute">{{ attribute.attribute }}</option>
                      </b-form-select>
                    </div>
                  </div>
                  <div v-if="selectedSettingsAttribute" class="col-12 form-group mb-0">
                    <hr class="my-3">
                    <div class="col-12 px-0 font-weight-bold">
                      {{ t('editingSettingLabel', 'editingSettingLabel') }}: {{ selectedSettingsAttribute}}
                    </div>
                    <div class="col-12 px-0">
                      {{ t('clientSettingsInfoText' + selectedSettingsAttribute, 'clientSettingsInfoText' + selectedSettingsAttribute) }}
                    </div>
                    <hr>
                    <div v-if="attributeData">
                      <div class="row mx-0 my-3 py-1 setting-border" v-for="(data, index) in attributeData" :key="data.id">
                        <div class="col-4 setting-label flex-display">{{ data.data_key }}</div>
                        <textarea class="col-8 form-control" v-model="attributeData[index].data_value" rows="2"></textarea>
                      </div>
                      <div class="row mx-0">
                        <ResponseInfo v-if="getResponseInfo.responseName == 'clientSettings'" class="mb-3" />
                      </div>
                      <div class="col-12 px-0 my-0 py-1 text-right">
                        <span class="btn btn-primary" @click="updateSettingsData()">{{ t('updateSelectedClientSettingsBtn', 'updateSelectedClientSettingsBtn') }}</span>
                      </div>
                    </div>
                    <div v-else>
                      <span>{{ t('noClientSettingsDataFound', 'noClientSettingsDataFound') }}</span>
                    </div>
                  </div>
                </template>
                <template v-else-if="!loadingList && !attributeList">
                  <div class="col-12 px-0 text-left">
                    <span>{{ t('noClientAttributesFoundText', 'noClientAttributesFoundText') }}</span>
                  </div>
                </template>
                <template v-else>
                  <loading
                      id="settings-loading-spinner"
                      class="align-items-center quicklink-loader"
                      :color="'#047bf8'"
                      :loader="'spinner'"
                      :active="loadingList"
                      :transition="'fade'"
                      :is-full-page="false">
                  </loading>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import ResponseInfo from '@/components/ResponseInfo.vue'
import Loading from 'vue-loading-overlay'

export default {
  name: 'ClientSettings',
  data() {
    return {
      attributeList: null,
      selectedSettingsAttribute: null,
      attributeData: null,
      loadingList: false
    }
  },
  components: {
    ResponseInfo,
    Loading
  },
  computed: {
    ...mapGetters(['getUserDetails', 'getResponseInfo']),
  },
  created() {
    this.getSettingsList()
  },
  methods: {
    getSettingsList() {
      this.$store.dispatch('clientSettingsStore/getSettingsList').then(response => {
        if(response) {
          this.attributeList = response
        }
      })
    },
    setClientSettingAttribute(event) {
      this.attributeData = null
      this.$store.dispatch('clientSettingsStore/getSettingsData', event).then(response => {
        if(response) {
          this.attributeData = response
        }
      })
    },
    updateSettingsData() {
      this.$store.dispatch('alertClearResponse')
      this.$store.dispatch('clientSettingsStore/updateSettingsData', {
        attributedata: this.attributeData
      })
    }
  }
}
</script>

<style>
  .flex-display {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .setting-label {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
  .setting-border {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
</style>
